import '../styles/style.css';

export default function Title({title, id,}) {

    return <h2 data-aos="fade-up" id={id}> {title}</h2>;
}